import { FC, useEffect, useState, Dispatch } from 'react';
import { Grid, MenuItem } from '@mui/material';
import { SMBSelect } from '../../../components';
import { IDropdownResponse } from '../../../models';
import { useQuery } from 'react-query';
import { getPartClassChildren } from '../../../fetch';

interface IManagePartsFiltersDropdown {
  partClassId: string | null;
  depth: number;
  setSelectedPartClassIdFilter: Dispatch<React.SetStateAction<string | null>>;
  hasAppliedFilters?: boolean;
  width?: number;
  required?: boolean;
}

export const ManagePartsFiltersDropdown: FC<IManagePartsFiltersDropdown> = ({
  partClassId,
  depth,
  setSelectedPartClassIdFilter,
  hasAppliedFilters,
  width,
  required
}) => {
  const { isLoading: isLoadingDropdown, data: partClassChildren } = useQuery<
    IDropdownResponse[],
    Error
  >(['part-class-children', partClassId], async () => await getPartClassChildren(partClassId));

  const [selectedPartClassId, setSelectedPartClassId] = useState(null);

  useEffect(() => {
    if (!hasAppliedFilters) {
      setSelectedPartClassId(null);
      setSelectedPartClassIdFilter(partClassId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasAppliedFilters]);

  return partClassChildren?.length > 0 ? (
    <>
      <Grid item xs={12} sm={width || 4}>
        <SMBSelect
          required={required ? true : false}
          onChange={e => {
            setSelectedPartClassId(e.target.value);
            setSelectedPartClassIdFilter(e.target.value);
          }}
          handleClear={() => {
            setSelectedPartClassId(null);
            setSelectedPartClassIdFilter(partClassId);
          }}
          variant="outlined"
          name={`selectedPartClassId-${depth ?? 0}`}
          label={depth ? `Sub Category` : `Part Class`}
          id={`selectedPartClassId-${depth ?? 0}`}
          value={selectedPartClassId}
          disabled={isLoadingDropdown}
          InputLabelProps={{ shrink: !!selectedPartClassId }}
        >
          {partClassChildren?.map((partClass: any, index) => {
            return (
              <MenuItem key={`${index + 1}`} value={partClass.value}>
                {partClass.description}
              </MenuItem>
            );
          })}
        </SMBSelect>
      </Grid>

      {selectedPartClassId && (
        <ManagePartsFiltersDropdown
          partClassId={selectedPartClassId}
          depth={depth + 1}
          setSelectedPartClassIdFilter={setSelectedPartClassIdFilter}
          width={width || 4}
        />
      )}
    </>
  ) : null;
};
